import { render, staticRenderFns } from "./_cookie-text-templates.vue?vue&type=template&id=487eef90"
import script from "./_cookie-text-templates.vue?vue&type=script&lang=js"
export * from "./_cookie-text-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports